const Homepage = {
  init() {
    this.initShopByCategorySwiper();
    this.initBestSellingProductSwiper();
    this.initTopSellingSwiper();
    this.initProductCollectionStyle2Swiper();
    this.initProductCollectionStyle3Swiper();
    this.initFlashSaleSwiper();

    if (typeof Theme.lazyLoadInstance !== "undefined") {
      Theme.lazyLoadInstance.update();
    }
  },
  pendingSliders(selector, root) {
    return Array.from((root || document).querySelectorAll(selector)).filter(
      (slider) => !slider.classList.contains("swiper-initialized"),
    );
  },
  productBreakpoints() {
    return {
      320: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
      1400: {
        slidesPerView: 6,
        spaceBetween: 20,
      },
    };
  },
  flashSaleMotion() {
    return {
      speed: 900,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
    };
  },
  initShopByCategorySwiper() {
    this.pendingSliders(".category-list__slider").forEach((slider) => {
      new Swiper(slider, {
        navigation: {
          nextEl: ".category-list__next",
          prevEl: ".category-list__prev",
        },
        loop: true,
        spaceBetween: 20,
      });
    });
  },
  initBestSellingProductSwiper() {
    this.pendingSliders(".best-selling-product__slider").forEach((slider) => {
      const wrapper = slider.closest(".best-selling-product__body") || slider.parentElement;
      const nextBtn = wrapper ? wrapper.querySelector(".best-selling-product__next") : null;
      const prevBtn = wrapper ? wrapper.querySelector(".best-selling-product__prev") : null;

      new Swiper(slider, {
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        slidesPerView: 1,
        loop: true,
        spaceBetween: 0,
        ...(slider.closest(".flash-sale-v2-products") ? this.flashSaleMotion() : {}),
        breakpoints: this.productBreakpoints(),
      });
    });
  },
  initTopSellingSwiper() {
    [
      [".top-rate__slider", ".top-rate__next", ".top-rate__prev"],
      [".top-items__slider", ".top-items__next", ".top-items__prev"],
      [".top-collection__slider", ".top-collection__next", ".top-collection__prev"],
    ].forEach(([sliderSelector, nextSelector, prevSelector]) => {
      this.pendingSliders(sliderSelector).forEach((slider) => {
        const card = slider.closest(".top-selling-product__card") || document;

        new Swiper(slider, {
          navigation: {
            nextEl: card.querySelector(nextSelector),
            prevEl: card.querySelector(prevSelector),
          },
          slidesPerView: 1,
          loop: true,
          spaceBetween: 20,
        });
      });
    });
  },
  initProductCollectionStyle2Swiper() {
    document.querySelectorAll(".product-collection-style-2").forEach((section) => {
      const slider = this.pendingSliders(".product-collection-style-2__slider", section)[0];
      const nextButton = section.querySelector(".product-collection-style-2__next");
      const prevButton = section.querySelector(".product-collection-style-2__prev");

      if (slider && nextButton && prevButton) {
        new Swiper(slider, {
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          slidesPerView: 1,
          loop: true,
          spaceBetween: 0,
          breakpoints: this.productBreakpoints(),
        });
      }
    });
  },
  initProductCollectionStyle3Swiper() {
    document.querySelectorAll(".product-collection-slides").forEach((section) => {
      const slider = this.pendingSliders(".product-collection-slides__slider", section)[0];
      const nextButton = section.querySelector(".product-collection-slides__next");
      const prevButton = section.querySelector(".product-collection-slides__prev");
      const pagination = section.querySelector(".product-collection-slides__pagination");

      if (slider && nextButton && prevButton) {
        new Swiper(slider, {
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          slidesPerView: 1,
          loop: true,
          spaceBetween: 0,
          pagination: {
            el: pagination,
            clickable: true,
          },
          breakpoints: this.productBreakpoints(),
        });
      }
    });
  },
  initFlashSaleSwiper() {
    this.pendingSliders(".flash-sale-swiper").forEach((slider) => {
      const section = slider.closest(".flash-sale-section");

      new Swiper(slider, {
        slidesPerView: 1.2,
        spaceBetween: 10,
        loop: true,
        ...this.flashSaleMotion(),
        pagination: {
          el: section ? section.querySelector(".flash-sale-progress-bar") : null,
          type: "progressbar",
        },
        breakpoints: {
          320: {
            slidesPerView: 1.2,
            spaceBetween: 10,
          },
          480: {
            slidesPerView: 1.5,
            spaceBetween: 16,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          992: {
            slidesPerView: 2.7,
            spaceBetween: 15,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          1400: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1600: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      });
    });
  },
};

$(document).ready(function () {
  Homepage.init();
});

document.addEventListener("shortcode.loaded", function () {
  Homepage.init();
});
